import { render, staticRenderFns } from "./ModalShare.vue?vue&type=template&id=34c6342e&scoped=true&"
import script from "./ModalShare.vue?vue&type=script&lang=js&"
export * from "./ModalShare.vue?vue&type=script&lang=js&"
import style0 from "./ModalShare.vue?vue&type=style&index=0&id=34c6342e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c6342e",
  null
  
)

component.options.__file = "ModalShare.vue"
export default component.exports